import React from 'react';
import PropTypes from 'prop-types';
import './ConfirmableLink.scss';

class ConfirmableLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      askConfirm: false,
    };
  }

  handleClickTrigger() {
    this.props.onClickTrigger();
    this.setState({ askConfirm: true });
  }

  handleClickCancel() {
    this.props.onClickCancel();
    this.setState({ askConfirm: false });
  }

  renderCopy() {
    const copy = this.state.askConfirm ? this.props.confirmCopy : this.props.triggerCopy;

    return (
      <div className={`confirmable-copy ${this.props.copyClassName}`} style={{ marginRight: this.props.spaceBetween }}>
        {copy}
      </div>
    );
  }

  renderTrigger() {
    const className = this.props.linkClassName;

    return (
      <a
        role="button"
        tabIndex="0"
        className={`confirmable-trigger ${className}`}
        onClick={() => this.handleClickTrigger()}
      >
        {this.props.triggerCTA}
      </a>
    );
  }

  renderConfirmation() {
    const { spaceBetween } = this.props;
    const className = this.props.linkClassName;

    return (
      <span>
        <a
          role="button"
          tabIndex="0"
          className={`confirmable-submit ${className}`}
          onClick={() => this.props.onSubmit()}
        >
          {this.props.confirmCTA}
        </a>
        <a
          style={{ marginLeft: spaceBetween }}
          role="button"
          tabIndex="0"
          className={`confirmable-cancel ${className}`}
          onClick={() => this.handleClickCancel()}
        >
          {this.props.cancelCTA}
        </a>
      </span>
    );
  }

  render() {
    return (
      <div className="confirmable-link-container">
        {this.props.showCopy && this.renderCopy()}
        {this.state.askConfirm ? this.renderConfirmation() : this.renderTrigger()}
      </div>
    );
  }
}

ConfirmableLink.propTypes = {
  confirmCopy: PropTypes.string,
  triggerCopy: PropTypes.string,
  triggerCTA: PropTypes.string.isRequired,
  confirmCTA: PropTypes.string,
  cancelCTA: PropTypes.string,
  spaceBetween: PropTypes.string,
  linkClassName: PropTypes.string,
  copyClassName: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClickTrigger: PropTypes.func,
  onClickCancel: PropTypes.func,
  showCopy: PropTypes.bool,
};

ConfirmableLink.defaultProps = {
  triggerCopy: 'Take this action?',
  confirmCopy: 'Confirm this action?',
  confirmCTA: 'Confirm',
  cancelCTA: 'Cancel',
  spaceBetween: '20px',
  linkClassName: 'medium-weight body-text-2',
  copyClassName: 'normal-weight body-text-2',
  showCopy: true,
  onClickCancel: () => null,
  onClickTrigger: () => null,
};

export default ConfirmableLink;
